import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import '../css/TemplateBuilder.css';
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import Faq from "../Common/Faq";
import { useEffect } from "react";




const TemplateBuilder = () => {
  return (
    <>
      <Header />
      <div className="container">
        <section className="hero-section">
          <div className="hero-text">
            <h2>Build Beautiful Email Templates with Ease</h2>
            <p>Design stunning, professional emails without writing a single line of code. With Sess, you can:</p>
            <ul>
              <li><strong>🌿  Drag & Drop Email Builder</strong> – Easily create custom email templates using our intuitive drag-and-drop interface. Add images, buttons, text blocks, and more in seconds — no design skills needed....</li>
              <li><strong>🖥️Advanced HTML Editor</strong> – For tech-savvy users and developers, switch to the built-in HTML editor and craft fully customized templates with complete control over code and layout....</li>
              <p>
                Whether you’re launching a campaign, sending an update, or automating customer emails — Sess gives you the flexibility and power to create emails your audience will love.
              </p>

            </ul>
            <button className="cta-btn">Get Started Now</button>
          </div>
          <div className="hero-image">
            {/* <img src={newTemplateImg} alt="New Template" className="main-template" /> */}

            <div className="template-options">
              {/* <img src={newTemplateLayout} alt="Layout Template Editor" />
            <img src={newTemplateHtml} alt="HTML Editor" /> */}
              <img src="./images/drag.jpg" alt="Layout Template Editor" />
              <img src="./images/drop.jpg" alt="HTML Editor" />
            </div>
          </div>
        </section>

        {/* Drag Builder Section */}
        <section className="drag-builder">
          <h3>Drag & Drop Builder</h3>
          <div className="builder-content">
            {/* <img src={drag-editor.png} alt="Drag Editor" /> */}
            <img src="./images/drag and drop.jpg" alt="Drag Editor" />
            <ul>
              <li>✅ <strong>No Coding Required</strong>: Build beautiful emails...</li>
              <li>✅ <strong>Pre-Built Elements</strong>: Instantly add images, buttons...</li>
              <li>✅ <strong>Intuitive Interface</strong>: Simply drag elements...</li>
              <li>✅ <strong>Custom Styling Options</strong>: Easily adjust fonts...</li>
              <li>✅ <strong>Responsive by Default</strong>: All designs automatically adapt...</li>
              <li>✅ <strong>Live Preview</strong>: See changes in real time...</li>
              <li>✅ <strong>Reusable Blocks</strong>: Save custom sections...</li>
              <li>✅ <strong>Smart Grid System</strong>: Snap-to-grid ensures perfect...</li>
              <li>✅ <strong>Faster Design Workflow</strong>: Build, edit, and finalize...</li>
            </ul>
          </div>
        </section>

        {/* HTML Editor Section */}
        <section className="html-editor">
          <h3>HTML Editor</h3>
          <div className="editor-content">
            <div className="editor-text">
              <ul>
                <strong>Build emails your way with our powerful HTML Editor</strong>
              </ul>
              <ul>
                Whether you're a coding expert or just want precise control, our editor lets you write, edit, and preview custom HTML for your emails in real-time.
              </ul>
              <ul>
                Create pixel-perfect designs, embed media, and fine-tune every element with clean, responsive code.
              </ul>
              <ul>
                Enjoy syntax highlighting, live previews, and total flexibility to bring your email vision to life — no restrictions, just full creative freedom.
              </ul>
            </div>
            {/* <img src={htmlEditorImg} alt="HTML Editor Preview" /> */}
            <img src="./images/htmleditor.jpg" alt="HTML Editor Preview" />
          </div>
        </section>

        {/* Call to Action */}
        <section className="cta-final">
          <p>Whether you're a designer looking for a simple drag-and-drop experience or a developer who prefers full control with custom HTML, our Email Template Builder gives you the flexibility and power to create stunning, responsive emails effortlessly. Start building professional templates today — faster, smarter, and your way.e...</p>
        </section>

        



      </div>
   <Faq
        endpoint="/api/faq/GetFaqList" // only endpoint, domain comes from .env
        params={{
          currentPage: 1,
          pageSize: 20,
          sortColumn: "FaqId",
          sortDirection: "asc",
          category: "Login Issues"
        }}
      />
      <Footer />
    </>
  );
}


export default TemplateBuilder;
